import { connect } from 'react-redux';
import { SURVEYS_RESPONSE_EXPORT } from 'next/entities/features';
import SurveyResponses from 'next/components/SurveyResponses/SurveyResponses';
import { selectAccountFeature } from 'reducers/account/features';
import { fetchSurveys, selectResponse } from 'entities/surveys';
import { asPromised } from 'utils/as-promised';

const mapStateToProps = (state, { flowId: id }) => ({
  surveys: selectResponse(state, id),
  hasSurveysExport: selectAccountFeature(state, SURVEYS_RESPONSE_EXPORT),
});
const mapDispatchToProps = (dispatch, { flowId: id, start, end }) => ({
  onLoad: () => asPromised(dispatch, fetchSurveys(id, start, end)),
});

export default connect(mapStateToProps, mapDispatchToProps)(SurveyResponses);
